var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightLong = function SvgArrowRightLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.47 13.03a.75.75 0 0 0 1.06 0l4.5-4.5a.75.75 0 0 0 .052-1.004l-.052-.056-4.5-4.5a.75.75 0 1 0-1.06 1.06l3.22 3.22H2.5a.75.75 0 0 0 0 1.5h9.19l-3.22 3.22a.75.75 0 0 0 0 1.06"
  })));
};
export default SvgArrowRightLong;